import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionInventoryInfo, } from "../../info/inventory/actionInventoryInfo";
export var epicSoundsSpendGold = function (action$) {
    return action$.pipe(filter(function (action) {
        var typeIsRemove = action.type === TypeActionInventoryInfo.RemoveResource;
        var isGoldSpend = (action.items || []).some(function (item) { return item.typeId === IdResource.Gold; });
        return typeIsRemove && isGoldSpend;
    }), tap(function () { return utilSound.event(IdEventSoundCore.SpendGold); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsSpendGold.ts
// module id = 2412
// module chunks = 3